import React from "react";

const Information = () => {
  return (
    <div className="flex flex-col items-start sm:px-16 p-6">
      <h1 className="text-[1.9rem] font-bold tracking-wide ">
        P.
        <span className="text-[#01A7D1] "> GENERAL INFORMATION</span>
      </h1>
      <p className="text-md  text-[#444444] tracking-wide pt-3">
        <h1 className="text-[1.5rem] font-bold tracking-wide pb-3">
          1. Entire Terms of Use
        </h1>
        The Terms of Use, together with the Privacy Policy and any other legal
        notices or Additional Policies published by Yostel on the Platform,
        shall constitute the entire agreement between you and Yostel concerning
        the Platform. If any provision of the Terms of Use is deemed invalid by
        a court of competent jurisdiction, the invalidity of such provision
        shall not affect the validity of the remaining provisions of the Terms
        of Use, which shall remain in full force and effect.
      </p>
      <p className="text-md  text-[#444444] tracking-wide pt-3">
        No waiver of any provision of this Terms of Use shall be deemed a
        further or continuing waiver of such term or any other term, and Yostel
        's failure to assert any right or provision under these Terms of Use
        shall not constitute a waiver of such right or provision.
      </p>
      <p className="text-md  text-[#444444] tracking-wide pt-3">
        <h1 className="text-[1.5rem] font-bold tracking-wide pb-3">
          2. Section Headings
        </h1>
        The section headings in the Terms of Use are for convenience only and
        have no legal or contractual effect.
      </p>
    </div>
  );
};

export default Information;
